import { getStorage } from 'firebase/storage';
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { v4 as uuidv4 } from 'uuid';

export const FirebaseConfig = {
    apiKey: 'AIzaSyDOAEsAUH1kRdZiYbbAszQawiecpTxKDAQ',
    authDomain: 'unaffected-co.firebaseapp.com',
    databaseURL: 'https://unaffected-co.firebaseio.com',
    projectId: 'unaffected-co',
    storageBucket: 'unaffected-co.appspot.com',
    messagingSenderId: '750031752415',
    appId: '1:750031752415:web:34d90d3f3653676814ed6a',
};


const app = initializeApp(FirebaseConfig);

export const db = getFirestore(app);
export const storage = getStorage();
export const auth = getAuth(app);

export const docId = () => uuidv4();
